<template>
  <div class="catalog-wrapper repair-catalog-wrapper">
    <router-link
      tag="button"
      :to="getPath()"
      class="catalog-btn"
      @hover="show = !show"
    >
      {{ $t('repairCatalogContent') }}
    </router-link>
    <div class="catalog-box">
      <ul class="catalog-list">
        <li
          v-for="category in categories"
          :key="category._id"
          class="catalog-item"
        >
          <router-link :to="getPath(category.slug)">
            <span class="catalog-item-title"
              ><span class="catalog-item-title-content">{{
                category.name
              }}</span></span
            >
          </router-link>
          <div class="catalog-block">
            <div class="catalog-block-wrapper">
              <div class="catalog-block-list">
                <div
                  v-for="(subcategory, index) in getChunk(category.subData)"
                  :key="`repair-subcategory-${index}`"
                  class="catalog-block-list-item"
                >
                  <ul class="chunk-list">
                    <li
                      v-for="chunkItem in subcategory"
                      :key="chunkItem.slug"
                      class="chunk-list-item"
                    >
                      <router-link
                        :to="getPath(`${category.slug}/${chunkItem.slug}`)"
                        class="chunk-list-item-link"
                      >
                        <span class="chunk-list-item-title"
                          ><span class="chunk-list-item-title-content">{{
                            chunkItem.name
                          }}</span></span
                        >
                      </router-link>
                      <ul class="chunk-list-item-children">
                        <li
                          v-for="service in getServices(chunkItem.name)"
                          :key="service.slug"
                          class="chunk-list-item-child"
                        >
                          <router-link
                            :to="
                              getPath(
                                `${category.slug}/${chunkItem.slug}/${service.slug}`
                              )
                            "
                            class="chunk-list-item-child-link"
                          >
                            <span class="chunk-list-item-child-name"
                              ><span class="chunk-list-item-child-name-text">{{
                                service[`description_${$i18n.locale}`]
                              }}</span></span
                            >
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RepairPageMixin from '@/components/repair/RepairPageMixin'

export default {
  name: 'RepairCatalog',
  mixins: [RepairPageMixin],
  data() {
    return {
      show: false,
    }
  },
  methods: {
    getChunk(nodes) {
      const n = 3
      const size = Math.ceil(nodes.length / n)
      const list = Array.from({ length: n }, (v, i) =>
        nodes.slice(i * size, i * size + size)
      )

      return list
    },
    getServices(subcategorySlug) {
      return this.services.filter(
        ({ subcategory }) => subcategory === subcategorySlug
      )
    },
  },
}
</script>

<style>
.repair-catalog-wrapper {
  padding-left: 18px;
  padding-right: 0;
}
.repair-catalog-wrapper .catalog-box {
  justify-content: flex-end;
}
.repair-catalog-wrapper .catalog-btn:before {
  content: '\e928';
  font-family: 'fontello';
}
.repair-catalog-wrapper .catalog-item-title {
  flex-direction: row-reverse;
}
.repair-catalog-wrapper .catalog-item-title:after {
  content: '\e94e';
}
.repair-catalog-wrapper .catalog-item .catalog-block {
  left: auto;
  right: 223px;
}
</style>
